import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, race } from 'rxjs';
import { defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { currentEncounterId, isEmptyEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { AllergiesState } from '../../entities';
import { AllergiesApi } from '../../infrastructure';
import { AllergiesAction } from '../actions';

/**
 * Allergies effects
 */
@Injectable()
export class AllergiesEffects {
    /* Effect Declarations */

    /**
     * Load allergies effect
     */

    loadAllergies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AllergiesAction.loadAllergiesAction.action),
            switchMap(action =>
                race(
                    isEmptyEncounterId(this.store).pipe(
                        take(1),
                        map(() => AllergiesAction.loadAllergiesAction.clearAction()),
                    ),
                    from(
                        makeDefaultAsyncActionEffect(
                            this.allergiesApi
                                .getAllergies(action.encounterId)
                                .pipe(isSameEncounterFilter(currentEncounterId(this.store), action.encounterId)),
                            AllergiesAction.loadAllergiesAction,
                        ),
                    ).pipe(defaultIfEmpty(AllergiesAction.loadAllergiesAction.clearAction())),
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param allergiesApi AllergiesApi
     * @param store Store<AllergiesState>
     */
    constructor(private actions$: Actions, private allergiesApi: AllergiesApi, private store: Store<AllergiesState>) {}
}
